import i18next from 'i18next';
import viLang from './lang/vi.es.js';
import enLang from './lang/en.es.js';

const NAMESPACE = 'order';
const t = (keys, options) => {
    return i18next.t(keys, Object.assign(Object.assign({}, options), { ns: NAMESPACE, interpolation: { escapeValue: false } }));
};
const lang = {
    vi: viLang,
    en: enLang,
};

export { NAMESPACE, lang, t };
